
export enum GlobalActions {
    HIPPA_RESET = 'HIPPA_RESET',
};